import { baseApi } from "../baseApi";
import { formatDateTime, glooproNumberFormat } from "@/utils/helpers";

export const purchaseOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPurchaseOrders: builder.query({
      query: (vendorId) => ({
        url: `/vendor/${vendorId}/opos`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        const toDisplayItem = (item: any) => {
          const formattedDate = formatDateTime(item?.created_at, "en-GB", "—");
          const totalAmountValue =
            item?.order_history?.total_amount ?? item?.total_amount;
          const formattedTotalAmount =
            totalAmountValue !== undefined &&
            totalAmountValue !== null &&
            totalAmountValue !== ""
              ? glooproNumberFormat(totalAmountValue)
              : "—";

          // Determine status based on accepted_by_vendor:
          // 1 = accepted, 0 = declined, null = pending
          let status: "pending" | "accepted" | "declined" = "pending";
          if (
            item?.accepted_by_vendor === 1 ||
            item?.accepted_by_vendor === true
          ) {
            status = "accepted";
          } else if (
            item?.accepted_by_vendor === 0 ||
            item?.accepted_by_vendor === false
          ) {
            status = "declined";
          } else {
            status = "pending"; // null or undefined
          }

          return {
            id: item?.id ?? "",
            poNumber: item?.document_number ?? "—",
            buyersName: item?.buyer_name ?? "—",
            dateReceived: formattedDate,
            totalAmount: formattedTotalAmount,
            status,
          };
        };

        const payload = Array.isArray(response?.data)
          ? response.data.map(toDisplayItem)
          : response?.data
            ? [toDisplayItem(response.data)]
            : [];

        return { ...response, data: payload };
      },
      providesTags: ["PurchaseOrders"],
    }),
    getPurchaseOrder: builder.query({
      query: (orderId) => ({
        url: `/vendor/opos/${orderId}`,
        method: "GET",
      }),
      providesTags: ["PurchaseOrders"],
    }),
    getPurchaseOrderPDF: builder.query({
      query: (orderId) => ({
        url: `/vendor/opos/${orderId}`,
        method: "GET",
        responseType: "blob", // For PDF files
      }),
      providesTags: ["PurchaseOrders"],
    }),
    acceptPurchaseOrder: builder.mutation({
      query: (orderId) => ({
        url: `/vendor/opos/${orderId}/accept`,
        method: "PUT",
      }),
      invalidatesTags: ["PurchaseOrders"],
    }),
    declinePurchaseOrder: builder.mutation({
      query: (orderId) => ({
        url: `/vendor/opos/${orderId}/reject`,
        method: "PUT",
      }),
      invalidatesTags: ["PurchaseOrders"],
    }),
  }),
});

export const {
  useGetPurchaseOrdersQuery,
  useGetPurchaseOrderQuery,
  useGetPurchaseOrderPDFQuery,
  useAcceptPurchaseOrderMutation,
  useDeclinePurchaseOrderMutation,
} = purchaseOrderApi;
